import cx from 'classnames'
import type { ReactNode } from 'react'

import { useThemeContext } from 'theme/themeProvider'

import { useCardHeightSync } from '../../hooks/useCardHeightSync'

import classes from './styles.module.scss'

type ReferFriendInfoCardProps = {
  title: string
  children: ReactNode
  imageUrl: string
  registerHeight: (id: string, height: number) => void
  maxHeight: number
}

export const ReferFriendInfoCard = ({
  title,
  children,
  imageUrl,
  registerHeight,
  maxHeight,
}: ReferFriendInfoCardProps) => {
  const { isDarkMode } = useThemeContext()
  const cardId = `card-${title}`

  const { containerRef, backgroundRef, rootRef, containerStyle, backgroundStyle, rootStyle } = useCardHeightSync({
    cardId,
    containerTopOffset: 12,
    registerHeight,
    maxHeight,
  })

  return (
    <div ref={rootRef} className={classes.root} style={rootStyle}>
      <div ref={backgroundRef} className={classes.pinkBg} style={backgroundStyle} />
      <img src={imageUrl} alt={imageUrl} className={classes.bgImage} />
      <div
        ref={containerRef}
        className={cx(classes.container, isDarkMode && classes.containerDarkMode)}
        style={containerStyle}
      >
        <div className={classes.title}>{title}</div>
        <div className={classes.text}>{children}</div>
      </div>
    </div>
  )
}
